export default __webpack_public_path__ + "static/media/trustErrorDark.fbd5c39b.svg";